import styled from 'styled-components';
import { colourPalette } from 'styles/styles';

export const PasswordChangePageStyle = {
  Container: styled.div``,
  Title: styled.h3`
    margin: 0;
    margin-bottom: 12px;
    font-weight: 400;
    font-size: 32px;
    line-height: 24px;
    color: #000000;
  `,
  Text: styled.p`
    margin-bottom: 32px;
    line-height: 24px;
    font-weight: 400;
    color: ${colourPalette.neutral500};
  `,
  AltText: styled.p`
    color: ${colourPalette.neutral500};
    font-size: 13px;
    font-weight: 400;
    line-height: 24px;
    margin: 0;
    margin-bottom: 24px;
  `,
};
